import {
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { TextField, Button, FormControl } from "@mui/material";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";
import { getAllProject } from "../../../api/casp/project";
import  SearchDropDownListPaginationComponent from "../common/SearchDropDownPaginationList";
import Settings_svg from "../../../assets/images/icons/jam_cog-f.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Role } from "../../../constants/Role";
import { useSelector } from "react-redux";
import { ProjectStatuses } from "../../../constants/Status";
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import { getSingleAgendaDetails,createAgendaItemsRoute,updateAgendaItem,deleteAgendaItemsRoute,updateAgendaRoute } from "../../../api/casp/agenda";
import Drawer from "@mui/material/Drawer";
import CloseIcon from '@mui/icons-material/Close';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { withTranslation } from "react-i18next";
import { getAllPortfolios } from "../../../api/casp/portfolio";
import { AttachFile } from "@mui/icons-material";
import { AcceptFileType } from "../../../constants/Common";
import { middleTruncate } from "../../../helpers/string_helper";

const EditAgendaSection = ({ submitEditAccordionReload, open, onClose, editAgendaId, t }) => {
  const [newAgenda, setNewAgenda] = useState({
    name: "",
    date: "",
    items: [],
    item: "",
    portfolios: null,
  });
  const [agendaEditLoading, setAgendaEditLoading] = useState(false);

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));
  const [editedItemIndex, setEditedItemIndex] = useState(null);
  const [editedItem, setEditedItem] = useState("");
 // const [editAgendaId, seteditAgendaId] = useState(editAgendaId);
  const [createdItems, setCreatedItems] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [matchingItems, setMatchingItems] = useState([]);
  const [unchangedItems, setUnchangesItems] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [isAddIconVisible, setIsAddIconVisible] = useState(false);
  const [prevDate, setPrevDate] = useState(null);
  const loggedInUser = useSelector((state) => state.Profile.user);     

  // const toggleAgendaEditModal = () => {
  //   setIsOpen(!isOpen);
  // };

  const agendaValidation = Yup.object().shape({
    name: Yup.string()
    .max(250, t("Too Long!"))
    .strict(true)
    .trim(t('Must not include leading and trailing spaces'))
    .required(t("Please enter name")),
  date: Yup.date()
    .typeError(t("Given date is invalid type"))
    .required(t("Please Enter date")),
  // projectId: Yup.number().nullable(),
  portfolios: Yup.object()
      .nullable()
      .required(t("Please select cohort")),
  item: Yup.string()
    .max(250, t("Too Long!"))
    .strict(true)
    .trim(t('Must not include leading and trailing spaces'))
    .typeError(t("Given item is invalid type"))
    .optional(),
    // .when('items', {
    //   is: (items) => items.length > 0,
    //   then: (schema) => schema.optional(),
    //   otherwise: (schema) => schema.required()
    // }),
  
  file: Yup.mixed()
      .nullable()
      .test(
        "fileSize",
        t("File size should be less than 10 MB"),
        (value) => !value || value.size <= 10 * 1024 * 1024
      ),
  // items: Yup.array().min(1).required(),
  items: Yup.array()
  .of(
    Yup.object().shape({
      description: Yup.string()
        .max(250, t("Too Long!"))
        .required(t("Please enter item name")),
      file: Yup.mixed().nullable(),
      action: Yup.string().oneOf(["create", "update", "delete"]).required(),
      id: Yup.string().nullable(),
      statusId: Yup.string().nullable(),
    })
  )
  .min(1, t("At least one item is required"))
  .required(),
  });

  const formik = useFormik({
    initialValues: {
      ...newAgenda,
    },
    validationSchema: agendaValidation,
    validateOnMount: false,
  });

//   const handleCreate = async () => {
//     try {
//       setAgendaEditLoading(true);
//      await Promise.all(createdItems.map(async (createdItem) => {
//        await createAgendaItemsRoute({agendaId: parseInt(editAgendaId), description:createdItem.description })
//     }))
//     await Promise.all(matchingItems.map(async (matchingItem) => {
//       await updateAgendaItem(parseInt(matchingItem.id),{agendaId: parseInt(editAgendaId), description:matchingItem.description, statusId: parseInt(matchingItem.statusId) })
//    }))
//    await Promise.all(deletedItems.map(async (deletedItem) => {
//     await deleteAgendaItemsRoute(parseInt(deletedItem.id),{agendaId: parseInt(editAgendaId) })
//  }))
//  const currentDate = new Date(formik.values.date); // Creating a Date object
// currentDate.setDate(currentDate.getDate() + 1);
// const isoDate = currentDate.toISOString();
//  const response = await updateAgendaRoute( parseInt(editAgendaId), {name: formik.values.name, date:isoDate, companyId:  loggedInUser.company.id} );
//       if (response.statusCode === 200) {
//         toast.success(response.data.message);
//         setNewAgenda({});
//         onClose();
//         setAgendaEditLoading();
//         submitEditAccordionReload(prevDate,response.data.data.date)
//               } 
//         else {
//         toast.error(response.data.message);
//         setAgendaEditLoading(false);
//       }
//     } catch (err) {
//       setAgendaEditLoading(false);
//       toast.error(err.message);
//     }
//   };

  // function newItemAddition() {
  //   if (formik.values.items.length >= 10) {
  //     return toast.error("You cannot add more than 10 item.");
  //   }

  //   formik.setFieldTouched("item", false, false);
  //   setCreatedItems([...createdItems,  { id: '', description: formik.values.item, action: 'create',statusId:'' }] );
  //   formik.setValues({
  //     ...formik.values,
  //    items: [
  //     ...formik.values.items,
  //     { id: '', description: formik.values.item, action: 'create',statusId:'' }
  //   ],
  //     item: "",
  //   });
  // }

  const handleCreate = async () => {
    try {
      setAgendaEditLoading(true);
      const formData = new FormData()

      const currentDate = new Date(formik.values.date); // Creating a Date object
      currentDate.setDate(currentDate.getDate() + 1);
      const isoDate = currentDate.toISOString();
      formData.append('name', formik.values.name);
      formData.append('companyId', user.company.id.toString()); // always string for multipart
      formData.append('date', isoDate);
      // formData.append('portfolioId', formik.values.portfolios.id.toString());

      // Items → each object has title + file
      formik.values.items.forEach((item, index) => {
        // console.log(item,'item');
        
        formData.append(`items[${index}][title]`, item.description);
        formData.append(`items[${index}][file]`, item.file || item?.fileName);
      });

    // console.log([...formData.entries()]);
    

      const response = await updateAgendaRoute(parseInt(editAgendaId),{formData});
      if (response.statusCode === 200) {
        toast.success(response.data.message);
        formik.setValues({
          ...newAgenda
        })
        formik.setFieldTouched()
        onClose();
        setAgendaEditLoading(false);
        submitEditAccordionReload(response.data.data.date, response.data.data.date)
      } else {
        toast.error(response.data.message);
        setAgendaEditLoading(false);
      }
    } catch (err) {
      setAgendaEditLoading(false);
      toast.error(err.message);
    }
  };

  const newItemAddition = () => {
    if (formik.values.items.length >= 10) {
          return toast.error("You cannot add more than 10 items.");
        }
    const newDescription = formik.values.item.trim().toLowerCase();
      const existingDescriptions = formik.values.items.map((i) =>
        i.description.trim().toLowerCase()
      );
    
      if (existingDescriptions.includes(newDescription)) {
        toast.error("File Name must be unique");
        return;
      }
    const newItem = {
      id: "",
      description: formik.values.item,
      file: formik.values.file,
      action: "create",
      statusId: "",
    };
    formik.setFieldValue("items", [...formik.values.items, newItem]);
    formik.setFieldValue("item", "");
    formik.setFieldValue("file", null);

    formik.setFieldTouched("items", false);
    formik.setFieldError("items", undefined);

    // re-run validation
    formik.validateForm();
  };

// console.log(formik.isValid,'formik.isValid');
// console.log(formik.errors,'formik.errors');

  function removeTask(index) {
    const items = formik.values.items.filter((_, i) => i !== index);
    formik.setValues({
      ...formik.values,
      items,
    });
  }


  const enableEditMode = (item, index) => {
      setEditedItemIndex(index);
      setEditedItem(item);
      setIsAddIconVisible(true);
    };
    const enableAddMode = (newVal, index, id) => {
      const updateAgendaItems = formik.values.items.map((item, i) => {
          if (i === index) {
             if(item.id ===''){
              const items = formik.values.items.filter((item, j) => j !== index && item.id === '');
              setCreatedItems([...items, {id: item.id, description: newVal,action:'create', statusId:''  }])
              return {id: item.id, description: newVal, action:'create', statusId:''  }; // Replace the value at the specified index with newVal
             }
             if(item.id !==''){

               let isDescriptionPresent = unchangedItems.find(_u => _u.description === newVal && _u.id === id);

                let updatedMatchingItems = matchingItems.filter(_u => _u.id !== item.id);

              if((isDescriptionPresent === undefined &&  item.id === id)){
                setMatchingItems([...updatedMatchingItems, {id: item.id, description:newVal,action:'update', statusId: item.statusId}])

              }
                else if(isDescriptionPresent &&  item.id === id && item.id === isDescriptionPresent.id&& Array.isArray(matchingItems) && matchingItems.every(item => typeof item === 'object') ){

                setMatchingItems(updatedMatchingItems);
              }
           
              return {id: item.id, description: newVal, action:'update', statusId:item.statusId  }; // Replace the value at the specified index with newVal
            }
          }
          return item; // Keep the other items unchanged
        });
        formik.setValues({
          ...formik.values,
          items:updateAgendaItems,
        });
        setEditedItemIndex(null)
        // setEditedItem(null)
        // setIsAddIconVisible(false)
    };
    const fetchAgendaDetails = async () => {
      try {
          const response = await getSingleAgendaDetails(editAgendaId);
          // console.log(response,'response');
          const fetchedItems = response.data.data.agendaItems;
          // formik.setFieldTouched("portfolios", true, true);
          formik.values.name =  response.data.data.name;     
          setPrevDate(response.data.data.date)     
          formik.values.date  = new Date(response.data.data.date).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
          });
          formik.setFieldValue('portfolios', {
            id: response.data.data.portfolio.id,
            label: response.data.data.portfolio.name,
            key: `${response.data.data.portfolio.id}|${response.data.data.portfolio.name}`,
            ...response.data.data.portfolio
          });
          
          
          // setSelectedProject({
          //   id: response.data.data.portfolio ? response.data.data.portfolio.id: '',
          //   label: response.data.data.portfolio?response.data.data.project.portfolio: '',
          //   key:response.data.data.portfolio? `${response.data.data.portfolio.id}|${ response.data.data.portfolio.name}`: '',
          // });
      
        //  let appendItems =[];
        //   fetchedItems.forEach((item, index) => {
        //     const newItem =  {id: item.id, description: item.description, action:'update', statusId: item.status.id}
        //     appendItems = [...appendItems, newItem];
           
        //   });
        //   setUnchangesItems(appendItems)

        //   formik.setFieldValue('items', appendItems);


        let appendItems = fetchedItems.map((item) => ({
          id: item.id,
          description: item.description,
          action: "update",
          statusId: item.status.id,
          fileUrl: item ? item.fileUrl : null,
          fileName: item ? item.fileName : null,
          file: null
        }));

        formik.setFieldValue("items", appendItems);
      } catch (error) {
        console.error("Error fetching agenda data:", error);
      }
    };

    useEffect(() => {    
      if (editAgendaId) {
        fetchAgendaDetails();
      }
    }, [editAgendaId,open]); // Dependency array for useEffect
  
  
  return (
    <React.Fragment>
      {/* <ModalHeader
        className="border-bottom-0"
        toggle={toggleAgendaEditModal}
      >
        Edit Agenda
      </ModalHeader> */}
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: { width: "580px" },
        }}
        className="projectListDrawer addRiskDrawer"
      >
        <form className="p-3">
          <h5 className="border-bottom-0">
            {t('Edit Course & Agenda')}
          </h5>
          <CloseIcon className="crossIcon" onClick={onClose} />
          <div className="innerTbContent">
            <div className="mb-3 plDatepicker">
              {/* <FormControl fullWidth> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      label={t("Course Date") + " *"}
                      className="form-control"
                      format="MM/DD/YYYY"
                      name="date"
                      disabled={true}
                      value={
                      formik.values.date ? dayjs(formik.values.date) : null
                      }
                      on
                      slotProps={{
                        field: {
                          clearable: true,
                          onBlur: (_) => {
                            if (!formik.touched?.date) {
                              formik.setFieldTouched("date", true, false);
                            }
                          },
                        },
                        onClear: () => {
                          formik.setFieldValue("date", "");
                        },
                      }}
                      onChange={(e) => {
                        formik.setFieldValue("date", e? dayjs(e).format('MM/DD/YYYY') : null);
                        if (!formik.touched?.estimatedStartDate) {
                          formik.setFieldTouched("date", true, false);
                        }
                      }}
                      required
                    />
                  </DemoContainer>
                </LocalizationProvider>
              {/* </FormControl> */}
              {formik.touched.date && formik.errors.date && (
                <span className="text-danger">{formik.errors.date}</span>
              )}
            </div>
            <div className="mb-3">
              <TextField
                id="outlined-basic"
                label={t("Course Name")}
                name="name"
                disabled={agendaEditLoading}
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                fullWidth
                required
              />
              {formik.touched.name && formik.errors.name && (
                <span className="text-danger">{formik.errors.name}</span>
              )}
            </div>
            {/* <div className="plSelectTypeField mb-3">
              <SearchDropDownListPaginationComponent
                size="small"
                label={t("Startups")}
                searchEnabled={false}
                defaultValue={selectedProject}
                onBlur={() => {
                  if (!formik.touched?.projectId) {
                    formik.setFieldTouched("projectId", true, true);
                  }
                }}
                disabled={true}
                listCall={getAllProject}
              
                emitItem={(newValue) => {
                  setSelectedProject(newValue);
                  formik.setFieldValue("projectId", newValue ? newValue.id : "");
                }}
                apiParams={{
                  filterFields: ["status"],
                  filterInputs: [
                    `${ProjectStatuses.DRAFT},${ProjectStatuses.ONGOING}`,
                  ],
                  order: "id",
                  direction: "asc",
                  ...(![
                    Role.EPMO_MANAGER,
                    Role.ROOT_ADMIN,
                    Role.VICE_PRESIDENT,
                    Role.PRESIDENT,
                    Role.PROGRAM_MANAGER,
                    Role.EPMO_OFFICER,
                  ].includes(user?.role?.name) && {
                    userId: user?.id,
                  }),
                }}
              />
              {formik.touched.projectId && formik.errors.projectId && (
                <span className="text-danger">{formik.errors.projectId}</span>
              )}
            </div> */}

            <div className="plSelectTypeField mb-3">
              <SearchDropDownListPaginationComponent
                // label={t("Cohort") + " *"}
                searchEnabled={false}
                disabled={true}
                // readOnly={isReadable}
                listCall={getAllPortfolios}
                disableClearable={!formik.values.portfolios}
                // defaultValue={Object.keys(formik.values.portfolios).length !== 0 ? formik.values.portfolios : undefined}
                defaultValue={formik.values.portfolios}
                apiParams={{
                    order: "updatedAt",
                    direction: "desc",
                    ...(![
                        Role.PROJECT_MANAGER,
                        Role.EPMO_MANAGER,
                        Role.ROOT_ADMIN,
                        Role.VICE_PRESIDENT,
                        Role.PRESIDENT,
                        Role.PROGRAM_MANAGER,
                        Role.EPMO_OFFICER,
                        Role.MENTOR
                    ].includes(user?.role?.name) && {
                        filterFields: "portfolioUser",
                        filterInputs: user.id,
                    }),
                }}
                emitItem={(newValue) => {
                    formik.setFieldTouched("portfolios", true, true);
                    formik.setFieldValue(
                        "portfolios",
                        newValue ? newValue : {}
                    );
                }}
                onBlur={() => {
                    if (!formik.touched?.portfolios) {
                        formik.setFieldTouched("portfolios", true, true);
                    }
                }}
              />
              {formik.touched.portfolios && formik.errors.portfolios && (
                  <span className="text-danger">
                      {formik.errors.portfolios}
                  </span>
              )}
            </div>
            {/* <div className="d-flex align-items-center mt-2">
                  <TextField
                    id="outlined-multiline-static"
                    label={t("Agenda Item")}
                    variant="outlined"
                    name="item"
                    disabled={agendaEditLoading}
                    fullWidth
                    value={formik.values.item}
                    onChange={formik.handleChange}
                    onBlur={() => {
                      // if (
                      //   !(formik.values.item || formik?.values?.items?.length) &&
                      //   !formik.touched.item
                      // ) {
                        formik.setFieldTouched("item", true, false);
                      // }
                    }}
                  />
                  {formik.touched.item && formik.errors.item && (
                    <span className="text-danger">{formik.errors.item}</span>
                  )}
                  <i
                    className={`las la-plus-circle d-inline-block ms-3 fw-semibold fs-22 text-primary ${
                      agendaEditLoading || formik.errors.item || !formik.values.item.trim() ? "text-secondary" : ""
                    }`}
                    style={{cursor: agendaEditLoading || formik.errors.item || !formik.values.item.trim() ? 'not-allowed' : 'pointer'}}
                    onClick={(e) => {
                      if (agendaEditLoading || formik.errors.item || !formik.values.item.trim()) {
                        e.preventDefault();
                        return
                      }
                      if (formik.values.item) {
                        newItemAddition();
                      } else {
                        formik.setFieldTouched("item", true, true);
                      }
                    }}
                  ></i>
            </div> */}
            {/* <ListGroup className="mt-2">
              {formik.values.items.map((item, index) => (
                <ListGroupItem
                  key={`${item.id} - ${index}`}
                  className="justify-content-between d-flex"
                  style={{marginBottom: '6px', border: '1px solid #EBEDF5', borderRadius: '5px'}}
                >
                  <div className="d-flex" style={{ width: '100%', marginRight: '10px'}}>
                    <AssignmentOutlinedIcon className="rounded_ico" />
                    {editedItemIndex === index ? (
                        <TextField
                            id={`text-${item.id}-${index}`}
                            key={`text-${item.id}-${index}`}
                            value={editedItem}
                            onChange={(e) => {
                              // const tempValue = e.target.value
                              // if (!tempValue?.trim() || tempValue.length !== tempValue?.trim().length) {
                              // }
                              setEditedItem(e.target.value)
                            }}
                            autoFocus
                            size="small"
                            fullWidth
                        />
                        ) : (
                        <span className="ms-1" style={{ color: 'rgb(107, 112, 131)', display: 'inline-block',
                        width: 'calc(100% - 70px)'}}>{item.description}</span>
                    )}
                  </div>
                  <div className="d-flex">
                    <EditIcon className="text-secondary" id="editButton" color="primary" key={`edit-${item.id} - ${index}`} onClick={() => enableEditMode(item.description, index )}  style={{ display: isAddIconVisible && editedItemIndex === index ? 'none' : 'block', cursor: 'pointer', fontSize: '20px'}}>Edit</EditIcon>
                    <DoneIcon key={`add-${item.id} - ${index}`} onClick={(e) =>{ if(!editedItem?.trim() || editedItem?.trim().length !== editedItem.length) {e.preventDefault(); return} enableAddMode(editedItem, index, item.id)}}  style={{  fontSize: '20px', display: isAddIconVisible && editedItemIndex === index ? 'block' : 'none', cursor: !editedItem.trim() || editedItem?.trim().length !== editedItem.length ? 'not-allowed' : 'pointer' }} className={`${!editedItem.trim() || editedItem?.trim().length !== editedItem.length ? 'text-secondary' : 'text-success' }`}>Add</DoneIcon>
                    
                    <CloseIcon
                      className={`las la-times-circle text-secondary ${
                        agendaEditLoading || !formik.values.items.length ? "text-secondary" : ""
                      }`}
                      style={{ fontSize: '20px', cursor: agendaEditLoading || !formik.values.items.length ? 'not-allowed' : 'pointer'}}
                      onClick={(e) => {
                        if (agendaEditLoading || !formik.values.items.length) {
                          e.preventDefault()
                          return
                        }
                        if (isAddIconVisible && editedItemIndex === index) {
                          setEditedItemIndex(null);
                          setEditedItem('');
                          setIsAddIconVisible(false);
                        } else {
                          removeTask(index)
                        }
                      }}
                    />
                  </div>
                </ListGroupItem>
              ))}
            </ListGroup> */}

            <div className="col-sm-12 mb-3 mt-3">
              <div className="d-flex align-items-center gap-3 mb-3">
                {/* File Name Field (Half Width) */}
                <div style={{ flex: 1 }}>
                  <TextField
                    fullWidth
                    id="agendaItem"
                    label={t("File Name")}
                    name="item"
                    disabled={agendaEditLoading}
                    value={formik.values.item}
                    onChange={formik.handleChange}
                    onBlur={() => formik.setFieldTouched("item", true, false)}
                    type="text"
                  />
                  {formik.touched.item && formik.errors.item && (
                    <span className="text-danger">{formik.errors.item}</span>
                  )}
                </div>

                  {/* File Upload */}
                  <div
                    className="d-flex align-items-center position-relative"
                    style={{
                      flex: 1,
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      padding: "8px 12px",
                      cursor: agendaEditLoading ? "not-allowed" : "pointer",
                    }}
                  >
                    <AttachFile className="attachment_button me-2" />
                    <span className="text-truncate" style={{ flex: 1 }}>
                      {formik.values.file ? middleTruncate(formik.values.file.name) : t("Attach Document")}
                    </span>

                    <input
                      type="file"
                      accept={AcceptFileType.toString()}
                      name="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        formik.setFieldValue("file", file || null);
                      }}
                      onBlur={() => {
                        if (!formik.touched?.file) {
                          formik.setFieldTouched("file", true, false);
                        }
                      }}
                      style={{
                        opacity: 0,
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                        cursor: agendaEditLoading ? "not-allowed" : "pointer",
                      }}
                    />
                  </div>

                    {/* Plus Icon */}
                    <i
                      className={`las la-plus-circle fw-semibold fs-22 ${
                        agendaEditLoading ||
                        !formik.values.item.trim() ||
                        !formik.values.file ||
                        formik.errors.file
                          ? "text-secondary"
                          : "text-success"
                      }`}
                      style={{
                        cursor:
                          agendaEditLoading ||
                          !formik.values.item.trim() ||
                          !formik.values.file ||
                          formik.errors.file
                            ? "not-allowed"
                            : "pointer",
                      }}
                      onClick={(e) => {
                        if (
                          agendaEditLoading ||
                          !formik.values.item.trim() ||
                          !formik.values.file ||
                          formik.errors.file
                        ) {
                          e.preventDefault();
                          return;
                        }
                        newItemAddition();
                      }}
                    ></i>
              </div>

              {/* File Validation Message */}
                {formik.touched.file && formik.errors.file && (
                  <span className="text-danger">{formik.errors.file}</span>
                )}

              {/* Existing + New Agenda Items */}
              {formik.values.items.length > 0 && (
                <h5 className="mb-0 mt-2">{t("Added Course Items")}:</h5>
              )}

              <div>
                {formik.values.items
                .filter((item) => item.action !== "delete")
                .map((itemObj, index) => (
                  <div
                    className="d-flex mt-2 justify-content-between align-items-center"
                    key={index}
                    style={{
                      border: "1px solid #EBEDF5",
                      borderRadius: "5px",
                      padding: "6px 10px",
                    }}
                  >

                    <div className="d-flex align-items-center">
                      <AssignmentOutlinedIcon className="rounded_ico" />
                      <span
                        className="fw-semibold text-truncate"
                        title={itemObj.description}
                        style={{ maxWidth: "250px" }}
                      >
                        {itemObj.description}
                      </span>

                      {/* <div className="d-flex align-items-center ms-auto"> */}
                      {itemObj.file ? (

                        <div className="d-flex align-items-center ms-4 text-truncate">
                          <i className="ri-attachment-2 text-muted me-2" style={{ fontSize: '1rem' }}></i>
                          <span
                            className="text-muted text-truncate"
                            title={itemObj.file.name}
                            style={{ maxWidth: '200px' }}
                          >
                            {middleTruncate(itemObj.file.name)}
                          </span>
                        </div>
                      ) : itemObj.fileUrl ? (
                        <div className="d-flex align-items-center ms-4 text-truncate">
                          <i className="ri-attachment-2 text-muted me-2" style={{ fontSize: '1rem' }}></i>
                          <span
                            className="text-muted text-truncate"
                            title={itemObj.fileName}
                            style={{ maxWidth: '200px' }}
                          >
                            {middleTruncate(itemObj.fileName)}
                          </span>
                        </div>
                        // <span className='text-muted text-truncate ms-4' title={itemObj.fileName}> <i class="ri-attachment-2"></i> {middleTruncate(itemObj.fileName)}</span>
                      ) : null}
                      {/* </div> */}

                    </div>
                    <CloseIcon
                      className="text-danger"
                      style={{
                        cursor: agendaEditLoading ? "not-allowed" : "pointer",
                      }}
                      onClick={() => removeTask(index)}
                    />
                   </div>
                ))}
              </div>
            </div>

          </div>
          <div className="plsubmitButton">
            <Button
              className="submitBtn btn addNew_ProjectBtn"
              onClick={handleCreate}
              sx={{
                cursor: agendaEditLoading || !formik.isValid ? 'not-allowed' : 'pointer'
              }}
              variant="contained"
              disabled={agendaEditLoading || !formik.isValid}
            >
              {agendaEditLoading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
              )}
              <span className="visually-hidden">Loading...</span>
              <span style={{ textTransform: 'none' }}>{t('Update')}</span>
            </Button>
          </div>
        </form>
      </Drawer>
    </React.Fragment>
  );
}

export default withTranslation() (EditAgendaSection)